// extracted by mini-css-extract-plugin
export default {"overlayContainer":"FullScreenLoader__overlayContainer___MfmCJ","fullScreenModalContent":"FullScreenLoader__fullScreenModalContent___ggI7A"};